import React from "react";
import { Badge, colors } from "../design/badge";
import { VisitStatus } from "@visitproof/types";

interface VisitStatusBadgeProps {
  status: VisitStatus;
}

const VisitStatusBadge: React.FC<VisitStatusBadgeProps> = ({ status }) => {
  let color;
  let title;

  switch (status) {
    case "pending":
      color = "yellow";
      title = "Pending";
      break;
    case "pending_confirmation":
      color = "orange";
      title = "Awaiting Confirmation";
      break;
    case "scheduled":
      color = "blue"; // Indicates success or completion
      title = "Scheduled";
      break;
    case "canceled":
      color = "red"; // Signifies an alert or problem
      title = "Canceled";
      break;
    case "supervisor_started":
      color = "blue"; // Represents initiation, a neutral color indicating action
      title = "Supervisor Started";
      break;
    case "supervisor_arrived":
      color = "green"; // Indicates success or completion of arrival
      title = "Supervisor Arrived";
      break;
    case "supervisor_enroute":
      color = "orange"; // Suggests progress or movement
      title = "Supervisor Enroute";
      break;
    case "no_show":
      color = "red"; // Signifies an alert or problem
      title = "Supervisor No Show";
      break;
    case "supervisor_ended":
      color = "purple"; // Represents closure or completion
      title = "Supervisor Ended";
      break;
    case "completed":
      color = "emerald"; // Indicates success or completion
      title = "Completed";
      break;
    default:
      color = "yellow"; // Default color if status is unknown
      title = status;
  }

  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default VisitStatusBadge;
